import Rules from "./Rules";

/* node types which can't be created or edited in the normal way */
const SPECIAL_NODE_TYPE_CODES = ["inventory", "silo", "tank", "container"];

class NodeTypeRules extends Rules {
  static register: $TSFixMe;

  static specialNodeTypeCodes = SPECIAL_NODE_TYPE_CODES;

  static rules = {};

  static find = (node: $TSFixMe) => {
    const nodeTypeCode = node?.typeParentCode || node?.typeCode;
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (NodeTypeRules.rules[nodeTypeCode]) {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      return new NodeTypeRules.rules[nodeTypeCode](node);
    }
    return new NodeTypeRules(node);
  };

  node: $TSFixMe;

  constructor(node: $TSFixMe) {
    super();
    this.node = node;
  }

  isSpecialNode() {
    // Main objects like nodes have no tenant assigned as long as they use the official master data (like nodeType) offered in the public E+H tenant.
    return (
      this.node.tenantPublic === undefined &&
      (NodeTypeRules.specialNodeTypeCodes.includes(this.node.typeParentCode) ||
        NodeTypeRules.specialNodeTypeCodes.includes(this.node.typeCode))
    );
  }

  icon() {
    if (this.isSpecialNode()) {
      return "lcm-iot-icon-inventory-rounded";
    }
    return "icon-eh-folder";
  }

  iconPrimary() {
    return !this.isSpecialNode();
  }

  editPath() {
    return `/nodes/${this.node.id}/edit`;
  }

  detailsPath() {
    return `/nodes/${this.node.id}`;
  }

  deleteModalTitleKey() {
    return "node.actions.delete.modal_title";
  }

  unassignModalTitleKey() {
    return "node.actions.unassign.confirmation.title";
  }

  deleteModalMessageKey() {
    return "node.actions.delete.modal_message";
  }

  unassignModalMessageKey() {
    return "node.actions.unassign.confirmation.message";
  }

  deleteNotificationKey() {
    return "node.actions.delete.notification";
  }

  assignNotificationKey() {
    return "node.actions.assign.notification";
  }

  unassignNotificationKey() {
    return "node.actions.unassign.notification";
  }

  moveNotificationKey() {
    return "node.actions.move.success_notification";
  }

  moveInsufficientPermissionsNotificationKey() {
    return "node.actions.move.insufficient_permissions";
  }

  deleteAssignedRestrictionNotificationKey() {
    return "api.error.node.assigned_restriction";
  }

  status() {
    return "node";
  }

  editable() {
    return !this.isSpecialNode();
  }
}

NodeTypeRules.register = (nodeTypeCode: $TSFixMe, clazz: $TSFixMe) => {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  NodeTypeRules.rules[nodeTypeCode] = clazz;
};

export default NodeTypeRules;
